export interface IOnboardingData {
  studioName: string;
  locationName?: string;
  studioType: number | '';
  studioSlug: string;
  countryName: string | '';
  aggregatorType: aggregatorType | '';
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  termsAndConditions: boolean;
  privacyPolicy: boolean;
  dpa: boolean;
  isProvider: boolean;
  isUser: boolean;
  zipCode?: string;
  city?: string;
  street?: string;
  organisationId?: string;
  creationSource?: CreationSource;
  latitude?: number;
  longitude?: number;
}

export enum aggregatorType {
  'none',
  'usc',
  'onefit',
}

export enum onboardingPage {
  STUDIO = 'studio',
  USC = 'usc',
  DETAILS = 'details',
  VERIFY_EMAIL = 'verifyEmail',
}

export enum confirmationPage {
  SUCCESS = 'success',
  FAIL = 'fail',
}

export enum CreationSource {
  Fitogram = 'Fitogram',
  Migration = 'Migration',
  Api = 'Api',
  PartnerPortal = 'PartnerPortal',
}
